<template>
    <div class="timeline-header row" :style="`width: ${width};`" v-if="priority">
        <div :class="['header', HeaderPriorityClass()]">
            <div class="flex-y-center">
                <span class="label-key" v-if="PriorityFocused()">Focus:&nbsp;</span><span class="label">{{ priority.Name }}</span>
                <InformationDialog
                    :buttonIconSource="ButtonInformationSource()"
                    :size="20"
                    :name="priority.Name"
                    :showDialog="ShowInformationDialog(priority.Name)"
                    @toggle="ToggleInformationDialog($event)"
                    @close="CloseInformationDialog()"
                >
                    <p class="single">{{ priority.Description }}</p>
                </InformationDialog>
            </div>
            <p class="project-stats single"><b>{{ priority.TotalProjects }}</b> <i>projects spanning</i> <b>{{ priority.TotalYears }}</b> <i>years</i></p>
        </div>
    </div>
</template>

<script>
import InformationDialog from "@/components/InformationDialog.vue";

export default {
    name: "TimelineHeader",
    props: {
        priority: Object,
        width: String
    },
    components: { InformationDialog },
    data: () => ({
        informationDialog: {
            show: false,
            priority: ""
        }
    }),
    methods: {
        HeaderPriorityClass: function() {
            return `header-priority-type-${this.priority.PriorityType.toLowerCase()}`;
        },
        PriorityFocused: function() { return this.priority.PriorityType === "Focus"; },
        ButtonInformationSource: function() {
            const source = this.PriorityFocused() ? "IconInformationLight.png" : "IconInformationDark.png";
            return require(`@/assets/Images/${source}`);
        },

        // Information Dialog
        ToggleInformationDialog: function(informationDialog) {
            const { showDialog, priority } = informationDialog;
            this.informationDialog = {
                show: !showDialog,
                priority: priority
            };
        },
        ShowInformationDialog: function(priorityName) {
            const { show, priority } = this.informationDialog;
            return show && priority === priorityName;
        },
        CloseInformationDialog: function() {
            this.informationDialog = {
                show: false,
                priority: ""
            };
        }

    }
};
</script>